import React from 'react'
import PropTypes from 'prop-types'

export const TYPES = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
}

function getPlaceholderClassNames (props) {
  const { type } = props
  const baseClassName = 'gift-placeholder'
  const baseClassArray = [baseClassName]

  if (type) {
    baseClassArray.push(`${baseClassName}--${type}`)
  }

  return baseClassArray.join(' ')
}

function GiftPlaceholder (props) {
  return (
    <div className={getPlaceholderClassNames(props)} />
  )
}

GiftPlaceholder.propTypes = {
  type: PropTypes.string.isRequired,
}

GiftPlaceholder.defaultProps = {
  type: TYPES.MEDIUM,
}

export default GiftPlaceholder
